import ProductForm from "./ProductForm";
import { CreateProduct } from "../api";

function AddProduct() {
  const addProduct = async (data) => {
    try {
      const res = await CreateProduct(data);

      console.log(res.data);

      if (res.data.success) {
        alert("Product Added Successfully");
      }
    } catch (error) {
      console.log(error);
      alert("Failed to create product");
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h2 className="text-3xl font-bold mb-6">
        Add Product
      </h2>

      <ProductForm
        onSubmit={addProduct}
        buttonText="Add Product"
      />
    </div>
  );
}

export default AddProduct;